import { capitalize } from 'lodash';

import { formatPhoneNumber, ia } from 'lib/helpers/utility';

const columns = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  { field: 'f_name', headerName: 'First Name', valueFormatter: ({ value }) => capitalize(value) },
  { field: 'l_name', headerName: 'Last Name', valueFormatter: ({ value }) => capitalize(value) },
  {
    headerName: 'Practices',
    field: 'practices',
    valueFormatter: ({ value }) => {
      if (ia(value)) {
        return value.map((p) => p?.name).join(', ');
      }

      if (typeof value === 'string') {
        return capitalize(value);
      }

      return '';
    }
  },
  {
    field: 'phone',
    headerName: 'Phone',
    valueFormatter: ({ value }) => formatPhoneNumber(value)
  },
  { field: 'email', headerName: 'Email' },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => capitalize(value)
  }
];

export default columns;
